import React, { useState, useEffect } from 'react';

export default function ComingSoon() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const totalLines = 15;
  const [opacity, setOpacity] = useState(1);
  const [showYellowBox, setShowYellowBox] = useState(true);
  useEffect(() => {
    const interval = setInterval(() => {
      setOpacity(prev => (prev === 1 ? 0.4 : 1));
    }, 500);

    return () => clearInterval(interval);
  }, []);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentIndex(prevIndex => {
  //       if (prevIndex === 4) {
  //         setTimeout(() => {
  //           setCurrentIndex(10);
  //         }, 300);
  //         return prevIndex;
  //       }
  //       return (prevIndex + 1) % totalLines;
  //     });
  //   }, 1200);

  //   return () => clearInterval(interval);
  // }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prevIndex => {
        if (prevIndex === totalLines - 1) {
          // Check if it's the last index
          setShowYellowBox(false); // Hide the yellow box
          setTimeout(() => {
            setCurrentIndex(0); // Reset to 0
            setShowYellowBox(true); // Show the yellow box again
          }, 100); // Wait for 100ms
          return prevIndex;
        }
        return prevIndex + 1; // Move to the next index
      });
    }, 800);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative px-4 w-full h-full background-glow lg:px-0 abc">
      <div className="flex flex-col justify-between h-full">
        <img src="/assets/images/logo.png" alt="Logo" className="z-20 mx-auto mt-6 w-28 lg:w-40" />
        <div className="flex justify-center">
          <div className="hidden absolute z-10 justify-center items-center px-1 w-full h-32 lg:flex">
            <div className="relative w-full">
              <div
                className="h-px bg-white transition-opacity duration-500"
                style={{ opacity }}
              ></div>

              {Array.from({ length: totalLines }).map((_, index) => (
                <div
                  key={index}
                  className="absolute h-1.5 w-[2px] bg-white"
                  style={{
                    left: `${(index / (totalLines - 1)) * 100}%`,
                  }}
                />
              ))}

              {showYellowBox && (
                <div
                  className="absolute -top-4 h-10 w-10 border-4 border-[#FF991A] transition-all duration-500"
                  style={{
                    left: `${(currentIndex / (totalLines - 1)) * 100}%`,
                    transform: 'translateX(-50%)',
                  }}
                ></div>
              )}
            </div>
          </div>

          <div className="relative z-20 text-center bg-ellipse lg:rounded-full lg:w-1/2">
            <div>
              <div className="lg:text-[3.75rem] text-[3rem] font-semibold text-brand-magnolia lg:-mt-5 leading-none">
                Coming Soon
              </div>

              <p className="mt-6 text-base font-normal lg:text-lg text-grayscale-300">
                Building ▓▓▓▓▓ on Bitcoin.
              </p>

              <a
                href="https://x.com/omegaone_btc"
                target="_blank"
                rel="noopener noreferrer"
                className="flex w-fit items-center space-x-2 mx-auto mt-8 lg:px-6 px-4 py-2 bg-[#FF991A] hover:bg-[#666668] text-[#1B1B1F] text-lg font-semibold font-figtree rounded-lg transition duration-200"
              >
                <p>Follow us on</p>{' '}
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="#1B1B1F"
                  >
                    <path
                      d="M4.53893 5.5L10.7163 13.7596L4.5 20.4751H5.89916L11.3417 14.5955L15.7389 20.4751H20.5L13.9749 11.751L19.7611 5.5H18.3619L13.3498 10.9149L9.3 5.5H4.53893ZM6.59646 6.53051H8.78367L18.4422 19.4446H16.255L6.59646 6.53051Z"
                      fill="#1B1B1F"
                    />
                  </svg>
                </span>
              </a>
            </div>
          </div>
        </div>
        <div className="h-20"></div>
      </div>

      <div className="hidden absolute glow glow-top-left lg:block"></div>
      <div className="hidden absolute glow glow-top-right lg:block"></div>
      <div className="hidden absolute glow glow-bottom-left lg:block"></div>
      <div className="hidden absolute glow glow-bottom-right lg:block"></div>
    </div>
  );
}
